(function () {
  document.querySelectorAll('[data-sk-ftabs]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-ftab-target]'));
    const panels = Array.from(root.querySelectorAll('[data-ftab-panel]'));

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        const targetId = tab.dataset.ftabTarget;
        panels.forEach((panel) => {
          panel.classList.toggle('hidden', panel.id !== targetId);
        });
      });
    });
  });
})();
